import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { createEpicMiddleware } from 'redux-observable';
import { BrowserRouter as Router, Route } from 'react-router-dom';
// import persistState from 'redux-localstorage';

import 'rc-slider/assets/index.css';

import Main from './containers/Main';
import registerServiceWorker from './registerServiceWorker';

import rootReducer from './reducers';
import rootEpic from './epics';

const epicMiddleware = createEpicMiddleware(rootEpic);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(epicMiddleware),
    //persistState()
  )
);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Route component={Main} />
    </Router>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js